import * as React from 'react';
import { CONNECTED_API_TYPE } from '../../Model/Enums';

const ALT_TO_ICON = {
  [CONNECTED_API_TYPE.AGGREG8]: 'Aggreg8 logó',
  [CONNECTED_API_TYPE.SZAMLAZZHU]: 'Szamlazz.hu logó',
  [CONNECTED_API_TYPE.ADRIANA]: 'Adriana logó',
};

const ORIGINATE = Object.freeze({
  [CONNECTED_API_TYPE.AGGREG8]: '/img/aggre8_logo.png',
  [CONNECTED_API_TYPE.SZAMLAZZHU]: '/img/logo.svg',
  [CONNECTED_API_TYPE.ADRIANA]: '/img/adriana_logo.svg',
});

type IconType = {
  src?: string;
  originate: string;
  style?: React.CSSProperties;
};

const Icon = ({ src, originate, style }: IconType): React.ReactElement => (
  <img src={src ?? ORIGINATE[originate]} alt={ALT_TO_ICON[originate]} style={style} />
);

export default Icon;
